import { Box, Dialog, useTheme } from "@mui/material";
import { styled } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Share from "./components/Share";
import { useRouter } from "../../../utils/hooks/useRouter";
import {
  firebaseAndKvaIframeLog,
  firebaseAndKvaLog,
} from "../../../services/analytics/analytic.service";
import React from "react";
import { Modal, Spacing } from "kvweb-ui";
const ModalContent = styled("div")({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "800px",
  paddingLeft: "32px",
  paddingRight: "32px",
  height: "495px",
  borderRadius: "8px",
  background: "#fff",
  paddingTop: "47px",
  "&.modal-content-loading": {
    background: "transparent",
    display: "flex",
    justifyContent: "center",
  },
});

const ModalClose = styled("a")({
  width: "24px",
  height: "24px",
  position: "absolute",
  top: "20px",
  right: "20px",
  cursor: "pointer",
  color: "#aaa",
});
interface IProps {
  open: boolean;
  isAdminMerchant?: boolean;
  handCancel?: VoidFunction;
}
export default function ShareModal({
  open,
  handCancel,
  isAdminMerchant,
}: IProps) {
  const theme = useTheme();
  const router = useRouter();
  const handClickCloseIcon = () => {
    firebaseAndKvaLog(router.query.platform, "kv_mk_setting_share_close");
    firebaseAndKvaLog(router.query.platform, "kv_mk_setting_share_close");
    handCancel && handCancel();
  };
  return (
    <Modal
      open={open}
      onClose={handCancel}
      sxDialog={{
        width: "100%",
        maxWidth: 720,
        paddingY: Spacing["space-m"],
        paddingX: Spacing["space-l"],
        [theme.breakpoints.down("md")]: {
          maxWidth: "100%",
          marginX: 0,
          borderRadius: 0,
        },
      }}
    >
      <Box>
        <Share isAdminMerchant={isAdminMerchant} handClose={handCancel} />
      </Box>
    </Modal>
  );
}
